const convertToAmericanFormat = str => {
  return str
    .replace(/\./g, '') // Убираем все точки
    .replace(',', '.') // Заменяем запятую на точку
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Добавляем запятые как разделители тысяч
};

export default convertToAmericanFormat;
